/* src/app/modals/cbm-rating-modal/cbm-rating-modal.component.scss */
.modal_customer_body {
  width: 500px;
  height: 400px;
}
/*# sourceMappingURL=cbm-rating-modal.component.css.map */
